<template>
  <div class="layout">
    <div style="display: flex; justify-content: center">
      <img class="logo" src="../assets/MDE.png" alt="" srcset="" />
    </div>
    <p class="description">
      Start creating your own beautiful Markdown file / Github README Profile!
      <br />
      Use your mouse to drag and drop different elements on your README profile
      or file!
      <br />
    </p>
    <p class="description-bold" style="margin: 0.5rem 0">
      <strong>
        NOTE: This is still very early so expect some changes in the
        future!</strong
      >
    </p>
    <a href="https://mdeditorsy.sleekplan.app/" class="feedback"
      >Roadmap / Feedback</a
    >
    <div
      class="sidebar-right-button-text"
      @click="$router.push({ path: 'editor' })"
    >
      Create your Markdown FILE!
    </div>

    <p class="copyright">Made with ❤️ Issam El Nasiri</p>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style lang="scss" scoped>
.layout {
  width: 100vw;
  height: 100vh;
  background-color: #494647;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.sidebar-right-button-text {
  border: 0;
  cursor: pointer;
  height: 3.675rem;
  border-radius: 30px;
  font-size: 1rem;
  letter-spacing: 0.2px;
  min-height: 2.188em;
  min-width: 2.188em;
  margin-bottom: 0.626em;
  padding: 0.8em;
  margin: 0.3rem;
  color: white;
  font-family: "Rubik";
  font-weight: 600;
  background: #343233;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease;
  text-align: center;
  &:hover {
    background: lighten(#343233, 15%);
  }
}

.copyright {
  font-family: "Rubik";
  font-weight: 600;
  color: white;
  position: absolute;
  bottom: 1rem;
  text-align: center;
  z-index: 3;
}

.feedback {
  font-family: "Rubik";
  font-weight: 600;
  color: white;
  position: absolute;
  top: 1rem;
  right: 1rem;
  text-align: center;
  z-index: 3;
}

.description {
  font-family: "Rubik";
  font-weight: 400;
  color: white;
  //   margin-bottom: 4rem;
  z-index: 3;
  text-align: center;
  padding: 2rem;
}

.description-bold {
  font-family: "Rubik";
  font-weight: 400;
  color: white;
  //   margin-bottom: 4rem;
  z-index: 3;
  text-align: center;
}

.logo {
  max-width: 350px;
  width: 100%;
}
</style>
